import script from "./device-info.vue?vue&type=script&lang=ts&setup=true"
export * from "./device-info.vue?vue&type=script&lang=ts&setup=true"

import "./device-info.vue?vue&type=style&index=0&id=6a6d1dc5&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\yang'ya'fei\\Documents\\tianshu-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a6d1dc5"]])

export default __exports__